module.exports = __webpack_public_path__ + "img/torres_strait_islands.287d7bc6.svg";